import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

/**
 * Componente reutilizável para exibir os 3 estados de uma chamada de API:
 * - null  → loading (spinner)
 * - false → erro
 * - undefined → vazio (sem dados)
 * - qualquer outro valor → projeta o conteúdo via ng-content
 */
@Component({
    selector: 'app-api-state',
    templateUrl: './api-state.component.html',
    changeDetection: ChangeDetectionStrategy.Eager
})
export class ApiStateComponent {
  @Input() state: any;
  @Input() loadingText = 'Consultando...';
  @Input() errorText = 'Ocorreu um erro na consulta.';
  @Input() emptyText = 'Nenhum resultado encontrado.';
  @Input() errorImg = '/assets/img/erro.png';
  @Input() emptyImg = '/assets/img/vazio.png';
}
